import { chakra } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'

import { shouldForwardProp } from 'src/utils/should-forward-prop'

const attentionPulse = keyframes`
    0%, 100% {
        border-color: var(--scroll-button-border-color);
        color: var(--scroll-button-icon-color);
    }
    50% {
        border-color: var(--scroll-button-attention-pulse-color);
        color: var(--scroll-button-attention-pulse-color);
    }
`

export const Button = chakra('button', {
    baseStyle: ({ theme }) => {
        const { borderColor, shadow, attentionPulseColor, autoscrollOff, autoscrollOn } = theme.palette.scrollDownButton

        return {
            position: 'absolute',
            bottom: '72px',
            right: '8px',
            cursor: 'pointer',
            zIndex: 2,
            width: '36px',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            backgroundColor: autoscrollOff.backgroundColor,
            border: '1px solid',
            borderColor,
            borderRadius: '50%',
            boxShadow: shadow,
            color: autoscrollOff.iconColor,
            '--scroll-button-border-color': borderColor,
            '--scroll-button-icon-color': autoscrollOff.iconColor,
            '--scroll-button-attention-pulse-color': attentionPulseColor,
            '&[data-autoscroll-active="true"]': {
                color: autoscrollOn.iconColor,
                backgroundColor: autoscrollOn.backgroundColor,
                '--scroll-button-icon-color': autoscrollOn.iconColor,
            },
            '&[data-attention-pulsing="true"]': {
                animation: `${attentionPulse} 250ms ease-in-out 2`,
            },
            _after: {
                display: 'none',
                content: '""',
                width: '12px',
                height: '12px',
                position: 'absolute',
                top: '-2px',
                right: '-2px',
                backgroundColor: '#de2839',
                borderRadius: '50%',
            },
            '&[data-has-indicator="true"]::after': {
                display: 'block',
            },
        }
    },
    shouldForwardProp,
})
